<template>
  <ReservePage />
</template>

<script>
import ReservePage from '@/components/ReservePage.vue';

export default {
  name: 'ReservationPageView',
  components: {
    ReservePage,
  },
};
</script>